import axios from "axios"
import {countriesDataModel} from './stateCountry/countriesDataModel'

export const countryUserModel = {
  mutations: {
    /**
     * @param state
     * @param {Object} payload
     */
    fillData(state, payload) {
      state.countriesData.isGuest = payload.data['isGuest']
      state.countriesData.currencyDto = payload.data['currencyDto']
      state.countriesData.protocolHttps =  payload.data['protocolHttps']
      state.countriesData.listCountriesDomain =  payload.data['listCountriesDomain']
      state.countriesData.listCurrency =  payload.data['listCurrency']
    },
    /**
     * @param state
     */
    loadingData(state) {
      state.countriesData.loading = true
    },
  },
  getters: {

  },
  actions: {
    /** текущий домен */
    defineCountryUser({commit}) {
      axios.get('/site/define-country-user')
        .then(res => {
          if (res.data.status === 'ok') {
            commit('fillData', res.data)
          }
          if (res.data.status === 'empty') {
            commit('fillData', res.data)
          }
        })
        .finally(() => (
          commit('loadingData')
        ))
    },
  },
  modules: {
    countriesData: countriesDataModel
  },
  namespaced: true,
}